@if (recommendationStateService.productDetailYouMightLikeProducts$ | async; as products) {
   @if (products.length > 0) {
      <div class="py-5">
         <siko-b2b-carousel
            id="js--similar-products-tab"
            [title]="'pdp.tabs.youMayAlsoLike' | cxTranslate"
            [products]="products"
         />
      </div>
   }
}
